<script>
import VClamp from 'vue-clamp';

export default {
  name: 'CpSocialFeedPoliticalActivism',
  directives: {
    margin: require('../directives/margins').margin,
    marginTop: require('../directives/margins').marginTop,
    marginRight: require('../directives/margins').marginRight,
    marginBottom: require('../directives/margins').marginBottom,
    marginLeft: require('../directives/margins').marginLeft,
  },
  components: {
    CpGrid: require('../grid').default,
    CpGridItem: require('../grid-item').default,
    SidebarMenuPodiumIcon: require('./icons/podium-icon').default,
    SidebarMenuBlogIcon: require('./icons/blog-icon').default,
    SidebarMenuContributionIcon: require('./icons/contribution-icon').default,
    PollIcon: require('./icons/poll-icon').default,
    CpBaseSvgIcon: require('../base-svg-icon').default,
    VClamp,
  },
  data: function () {
    return {
      boxList: [
        {
          id: 1,
          title: 'My blogs',
          subtitle: "Check the articles you've created and shared with all the CrowdBlue community.",
          href: '/user/blogs',
        },
        {
          id: 2,
          title: 'My campaigns',
          subtitle: 'Follow the support your campaigns receive and track fundraising.',
          href: '/user/campaigns',
        },
        {
          id: 3,
          title: 'My contributions',
          subtitle: 'Check the status of your contributions and manage your payment method.',
          href: '/user/contributions',
        },
        {
          id: 4,
          icon: 'fas fa-hands-helping',
          title: 'My endorsements',
          subtitle: 'See the history of candidates and campaigns you support over the time.',
          href: '/user/endorsements',
        },
        {
          id: 5,
          icon: 'fas fa-calendar-day',
          title: 'My events',
          subtitle: 'Keep a record about the event you organized and which ones are coming up.',
          href: '/user/events',
        },
        {
          id: 6,
          icon: 'fas fa-users',
          title: 'My groups',
          subtitle: "Manage the groups you've created and interact with your communities.",
          href: '/user/groups',
        },
        {
          id: 7,
          icon: 'fas fa-file-signature',
          title: 'My petitions',
          subtitle: 'Track how many signatures your petitions collects and analyze support for causes.',
          href: '/user/petitions',
        },
        { id: 8, title: 'My polls', subtitle: 'Follow how your polls are going and to analyze the trends.', href: '/polls' },
      ],
    };
  },
};
</script>

<template>
  <div v-bind:class="{ container: $root.isSmallDesktop, 'container horizontalPadding': !$root.isSmallDesktop }">
    <cp-grid>
      <cp-grid-item :span="12">
        <h2 class="h2Text neutral6-color">My activity</h2>
      </cp-grid-item>
      <cp-grid-item :span="12">
        <p class="bodyText neutral6-color">Check out your political initiatives.</p>
      </cp-grid-item>
      <div class="anchorContainer">
        <cp-grid-item :span="$root.isMobile ? 12 : 6" v-for="item in boxList" :key="item.id">
          <a :href="item.href" class="boxContentContainer">
            <cp-base-svg-icon v-if="item.id === 1" class="box-icon" :width="30" :height="36" :viewBox="'0 0 36 30'">
              <sidebar-menu-blog-icon />
            </cp-base-svg-icon>
            <cp-base-svg-icon v-if="item.id === 2" class="box-icon" :width="30" :height="36" :viewBox="'0 0 36 30'">
              <sidebar-menu-podium-icon />
            </cp-base-svg-icon>
            <cp-base-svg-icon v-if="item.id === 3" class="box-icon" :width="30" :height="32" :viewBox="'0 0 36 30'">
              <sidebar-menu-contribution-icon />
            </cp-base-svg-icon>
            <cp-base-svg-icon v-if="item.id === 8" class="box-icon" :width="30" :height="32" :viewBox="'0 0 36 30'">
              <poll-icon />
            </cp-base-svg-icon>
            <span v-if="item.id !== 1 && item.id !== 2 && item.id !== 3 && item.id !== 8" :class="[item.icon, 'box-icon']" />
            <div class="textContainer">
              <h3 class="subheadline1 primary-color">{{ item.title }}</h3>
              <p class="bodyText neutral5-color" :class="{ textAliginCenter: !$root.isPhone }">
                {{ item.subtitle }}
              </p>
            </div>
          </a>
        </cp-grid-item>
      </div>
    </cp-grid>
  </div>
</template>

<style scoped>
.container {
  width: 100%;
  padding: 1.5em;
  margin-bottom: 2.5em;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
}
.horizontalPadding {
  padding-left: 17em !important;
  padding-right: 17em !important;
}
.boxContentContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #dadada;
  border-radius: 4px;
  margin: 0.5em;
  padding: 1em;
}
.anchorContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.box-icon {
  font-size: 32px;
  padding: 0 10px;
  color: var(--primary);
}
.textContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.textAliginCenter {
  text-align: center;
}
.grid div:nth-child(1),
.grid div:nth-child(2),
.grid h2 {
  margin-bottom: 0;
}
.grid p:first-child {
  margin: 0;
}
.h2Text,
.subheadline1 {
  font-weight: 700;
}
.h2Text {
  font-size: 31px;
}
.subheadline1 {
  font-size: 20px;
}
.bodyText {
  font-size: 17px;
  font-weight: 400;
}

@media only screen and (min-width: 1650px) and (max-width: 1870px) {
  .boxContentContainer {
    height: 150px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .text-banner-zip {
    width: 60%;
  }
}
@media only screen and (max-width: 767px) {
  .text-banner-zip {
    width: 90%;
    padding-right: 10px;
  }
}
@media only screen and (max-width: 400px) {
  .boxContentContainer {
    flex-direction: row;
  }
  .textContainer {
    width: 75%;
    align-items: flex-start;
  }
}
</style>
